module.exports = __webpack_public_path__ + "img/confeti.1d76bafb.svg";